import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';
import http from '../shared/HttpCommon';
import { CommunityManagement } from '../shared/interfaces/ICommunityManagement';
import { IGMBReviewFilter } from '../shared/interfaces/IGMBReviewFilter';

const getLastScores = async (
  location: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.post('/google/scores/last', { location }, { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const getScores = async (
  location: string,
  mode: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.post('/google/scores/filter', { location, mode }, { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const getAllLocations = async (
  offset = 0,
  pageSize = 0,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal,
  isActive?: boolean,
  orderBy?: string[],
  searchTerm?: string
) => {
  try {
    loading(true);
    const request: any = {
      offset,
      pageSize,
      orderBy,
      isActive,
    };
    if (searchTerm) {
      request.search = searchTerm;
    }
    const { data } = await http.post('/google/locations', request, {
      signal,
    });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const toggleLocationActive = async (ID: string, isActive: boolean) => {
  try {
    const { data } = await http.patch('/google/locations/crawler-status', {
      locations: [
        {
          ID,
          isActive,
        },
      ],
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const toggleLocationCommenting = async (ID: string, allowReviewResponses: boolean) => {
  try {
    const { data } = await http.patch('/google/locations/allow-response', {
      locations: [
        {
          ID,
          allowReviewResponses,
        },
      ],
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const setInterval = async (interval: string) => {
  try {
    const { data } = await http.patch('/google/auth/interval', {
      interval: interval,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const getReviewsPaginated = async (
  filter: IGMBReviewFilter,
  loading: Dispatch<SetStateAction<boolean>>,
  signal?: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.post('/google/reviews/pagination', filter, {
      signal,
    });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const replyToReview = async (
  locationId: string,
  reviewId: string,
  reply: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.put(`/google/locations/${locationId}/reviews/${reviewId}`, {
      comment: reply,
    });
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.log(error);
  }
};

const updateReviewReply = async (
  locationId: string,
  reviewId: string,
  reply: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.put(`/google/locations/${locationId}/reviews/${reviewId}`, {
      comment: reply,
    });
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.log(error);
  }
};

const deleteReviewReply = async (
  postgresLocationId: string,
  reviewId: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.delete(
      `/google/locations/${postgresLocationId}/reviews/${reviewId}`
    );
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.log(error);
  }
};

const saveCommunityManagementSettings = async (
  locationId: string,
  communityManagement: CommunityManagement,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    await http.patch('/google/locations/community-settings', {
      id: locationId,
      communityManagement,
    });
    loading(false);
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const GMBService = {
  getAllLocations,
  getReviewsPaginated,
  toggleLocationActive,
  toggleLocationCommenting,
  replyToReview,
  deleteReviewReply,
  saveCommunityManagementSettings,
  updateReviewReply,
  getLastScores,
  getScores,
  setInterval,
};

export default GMBService;
